import React, { useState, useEffect } from "react";


export default function TriesCount({
  answer,
  winpercentage,
  isGameLost,
  isGameWon,
}) {
    const value = localStorage.getItem("gameState");
    const parsedValue = value ? JSON.parse(value) : null; 
    const triesCount = parsedValue?.guesses?.length || 0; 
    const tryCount = Math.min(triesCount + 1, 6);
  const attemptCount = triesCount;
  const [delayTime, setDelayTime] = useState(false);

  let image = "";
  let text = "";
  if (isGameWon) {
    image = "/welldone.png";
    text = "Well done!";
  }
  if (isGameLost) {
    image = "/shitt.png";
    text = "Next Time!";
  }
  if(isGameWon || isGameLost) {
    setTimeout(() => {
        setDelayTime(true);
    }, 3000);
  }
  return (
    <div className="tries-count-body">
      <div className="tries-count">
        {(isGameWon || isGameLost) && delayTime == true ? (
          <>
            <div style={{ textAlign: "center" }}>
              <img style={{ height: "90px" }} src={image} />
              <h1 style={{ fontWeight: "bold" }}>{text}</h1>
            </div>

            <div>
              {isGameWon ? (
                <p
                  style={{
                    padding: "0 15px",
                    fontSize: "17px",
                    textAlign: "center",
                    lineHeight: "1",
                  }}
                >
                  You are among the {winpercentage}% of <br /> people who solved
                  today’s word <br /> in {attemptCount} tries.
                </p>
              ) : (
                <div style={{textAlign:'center'}}>
                  <h6 style={{fontSize:'16px', fontWeight:'700', margin:'0px'}} >Answer</h6>
                  <h4 style={{fontSize:'32px', fontWeight:'700'}} >{answer}</h4>
                </div>
              )}
            </div>
          </>
        ) : (
          <>
            <div style={{ textAlign: "center" }}>
              <h6
                style={{ fontWeight: "bold", margin: "0", lineHeight: "0.75" }}
              >
                TRIES
              </h6>
              <h1 style={{ fontWeight: "bold" }}>{triesCount}/6</h1>
            </div>

            <div>
              <p
                style={{
                  padding: "0 15px",
                  fontSize: "17px",
                  textAlign: "center",
                  lineHeight: "1",
                }}
              >
                {winpercentage}% of people solved today’s <br /> word in{" "}
                {tryCount} try.
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
